function getKeys() {
    const hostName = window.location.hostname;

    const res = {
        api: '',
        env: '',
        name: process.env.REACT_APP_NAME,
        TENANT: '',
        CLIENT_ID: '',
        ENDPOINT_ID: '',
        REDIRECT_URL: '',
        POST_LOGOUT_URL: ''
    };

    //LOCAL
    if (hostName === 'localhost') {
        res.requestTable = 'mock-requests.json'
        res.api = '/api'
        res.env = 'LOCALHOST'
        res.TENANT = "e3483448-2d42-454f-af68-9dd1368fa009"
        res.CLIENT_ID = "fb0f0cd3-c614-4cd1-9d29-6b546c73b0ac"
        res.ENDPOINT_ID = "https://graph.microsoft.com/v1.0/me"
        res.REDIRECT_URL = "http://localhost:5000/status"
        res.POST_LOGOUT_URL = "http://localhost:5000/status"
    }
    //TESTQA
    else if (hostName === 'datarights-c.testqa.zionsbank.com') {
        res.env = 'TEST'
        res.requestTable = '/api/statuscorrectsearch'
        res.api = '/api'
        res.TENANT = "e3483448-2d42-454f-af68-9dd1368fa009"
        res.CLIENT_ID = "fb0f0cd3-c614-4cd1-9d29-6b546c73b0ac"
        res.ENDPOINT_ID = "https://graph.microsoft.com/v1.0/me"
        res.REDIRECT_URL = "datarights-c.testqa.zionsbank.com/status"
        res.POST_LOGOUT_URL = "datarights-c.testqa.zionsbank.com/status"
    }
    //STAGING
    else if (hostName === 'datarights-c.staging.zionsbank.com') {
        res.env = 'STAGING'
        res.requestTable = '/api/statuscorrectsearch'
        res.api = '/api'
        res.TENANT = "e2418976-4544-4f71-aad4-b023e2f2cc53"
        res.CLIENT_ID = "10bc5cf4-9e72-411f-bff7-ecd417e0a579"
        res.ENDPOINT_ID = "https://graph.microsoft.com/v1.0/me"
        res.REDIRECT_URL = "https://datarights-c.staging.zionsbank.com/status"
        res.POST_LOGOUT_URL = "https://datarights-c.staging.zionsbank.com/status"
    }
    // PROD
    else if (hostName === 'datarights.zionsbancorp.com') {
        res.env = 'PROD'
        res.requestTable = '/api/statuscorrectsearch'
        res.api = '/api'
        res.TENANT = "c38f90d0-da54-455b-b1ae-c43b6009d294"
        res.CLIENT_ID = "4c500feb-8f93-4744-a682-f51516f7506a"
        res.ENDPOINT_ID = "https://graph.microsoft.com/v1.0/me"
        res.REDIRECT_URL = "https://datarights.zionsbancorp.com/status"
        res.POST_LOGOUT_URL = "https://datarights.zionsbancorp.com/status"
    }
    else {
        console.warn(`could not identify hostname: ${hostName}.`)
    }

    return res
}

export default getKeys()